import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useFontFamily = ({
  fontFamily,
  mobileFontFamily,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontFamily?: string
  mobileFontFamily?: string
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalFontFamily = usePage(pageSelectors.getGlobalFontFamily)

  const typographySelector = typographySelectorMap[typographyType]

  const {
    fontFamily: websiteGlobalFontFamily,
    mobileFontFamily: globalMobileFontFamily,
  } = useWebsiteSettings(typographySelector) || {}

  const globalFontFamily = pageGlobalFontFamily || websiteGlobalFontFamily

  return {
    calculatedFontFamily: getCalculatedProperty({
      desktopProperty: fontFamily === 'inherit' ? undefined : fontFamily,
      mobileProperty:
        mobileFontFamily === 'inherit' ? undefined : mobileFontFamily,
      globalDesktopProperty: globalFontFamily,
      globalMobileProperty: globalMobileFontFamily,
    }),
    globalFontFamily,
    globalMobileFontFamily: globalMobileFontFamily || globalFontFamily,
  }
}
